import tags from '../tags';

const {
  passives: {
    offensivePassive,
    defensivePassive,
    resourcePassive,
    mobilityPassive,
    healingPassive,
  },
} = tags;

export default [
  {
    name: 'Thrill of the Hunt',
    tags: [],
  },
  {
    name: 'Tactical Advantage',
    tags: [mobilityPassive],
  },
  {
    name: 'Blood Vengeance',
    tags: [resourcePassive],
  },
  {
    name: 'Steady Aim',
    tags: [offensivePassive],
  },
  {
    name: 'Cull the Weak',
    tags: [offensivePassive],
  },
  {
    name: 'Night Stalker',
    tags: [resourcePassive],
  },
  {
    name: 'Brooding',
    tags: [healingPassive],
  },
  {
    name: 'Hot Pursuit',
    tags: [mobilityPassive],
  },
  {
    name: 'Archery',
    tags: [offensivePassive],
  },
  {
    name: 'Numbing Traps',
    tags: [defensivePassive],
  },
  {
    name: 'Perfectionist',
    tags: [offensivePassive, resourcePassive],
  },
  {
    name: 'Custom Engineering',
    tags: [],
  },
  {
    name: 'Grenadier',
    tags: [offensivePassive],
  },
  {
    name: 'Sharpshooter',
    tags: [offensivePassive],
  },
  {
    name: 'Ballistics',
    tags: [offensivePassive],
  },
  {
    name: 'Leech',
    tags: [healingPassive],
  },
  {
    name: 'Ambush',
    tags: [offensivePassive],
  },
  {
    name: 'Awareness',
    tags: [defensivePassive],
  },
  {
    name: 'Single Out',
    tags: [offensivePassive],
  },
];
